import { memo, useCallback } from "react";
import { useTranslate } from "helpers";
import { TableSearch } from "ui/components/Table/TableSearch";
import { TableGrid } from "ui/components/Table/TableGrid";
import { initialDataWithPagination } from "services/api/consts";
import { FleetVehicleRow } from "services/api/fleet/vehicles/types";

import MarketplaceGridCard from "../MarketplaceGridCard/MarketplaceGridCard";
import { MARKETPLACE_VEHICLE_SEARCH_COLUMNS } from "./consts";
import { MarketplaceSearchResultsProps } from "./types";

// Rezultati marketplace pretrage — vlastita tablica i kartice, bez internih
// podataka iz flote (nabavna cijena, marže, status, akcije nad vozilom).
const MarketplaceSearchResults: React.FC<MarketplaceSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    selectableRows = false,
    viewType = "table",
    onRowClick,
    onPaginationChange,
    onSelectedChange,
  } = props;

  const { t } = useTranslate();

  const renderGridItem = useCallback(
    (vehicle: FleetVehicleRow) => {
      return <MarketplaceGridCard vehicle={vehicle} onRowClick={onRowClick} />;
    },
    [onRowClick]
  );

  if (viewType === "grid") {
    return (
      <TableGrid
        data={searchResults.data}
        renderItem={renderGridItem}
        pagination={searchResults.pagination || initialDataWithPagination.pagination}
        onPaginationChange={onPaginationChange}
        isLoading={isLoading}
        selectedItems={selectedRows}
        onSelectedChange={onSelectedChange}
        selectableItems={selectableRows}
      />
    );
  }

  return (
    <TableSearch
      columns={MARKETPLACE_VEHICLE_SEARCH_COLUMNS(t)}
      data={searchResults.data}
      selectedRows={selectedRows as unknown as number[]}
      pagination={searchResults.pagination || initialDataWithPagination.pagination}
      selectableRows={selectableRows}
      onPaginationChange={onPaginationChange}
      onSelectedChange={onSelectedChange as unknown as ((selected: number[] | number) => void) | undefined}
      isLoading={isLoading}
      onRowClick={onRowClick}
      isMinimized={true}
      size="full"
    />
  );
};

export default memo(MarketplaceSearchResults);
